import {DownOutlined, MenuOutlined} from "@ant-design/icons";
import {Button, Dropdown, Space} from "antd";
import React, {useContext, useState} from "react";
import {RefsContext} from "../context/refscontext";
import {DrawerContext} from "../context/drawercontext";
import {useLocation, useNavigate} from "react-router-dom";
import {FaPhone} from "react-icons/fa6";
import {ProjectsContext} from "../context/ProjectsContext";
import domesticProjects from "../Data/DomesticProjects";
import commercialProjects from "../Data/CommercialProjects";
import MobileDrawer from "./MobileDrawer";
import { useRef } from "react";

function Navbar({color = "bg-white"}) {
    const navbarRef = useRef(null);
    const location = useLocation();
    const navigate = useNavigate();
    const {homeRef, aboutRef, servicesRef} = useContext(RefsContext);
    const {showDrawer} = useContext(DrawerContext);
    const {setProjectsForType} = useContext(ProjectsContext);
    const [openMenu, setOpenMenu] = useState(false);

    const openDrawer = () => setOpenMenu(true);
    const onClose = () => setOpenMenu(false);

    // const scrollToSection = (ref) => {
    //     ref.current?.scrollIntoView({behavior: "smooth", block: "start"});
    //     onClose();
    // };
    const scrollToSection = (ref) => {
        if (ref.current && navbarRef.current) {
            const navbarHeight = navbarRef.current.offsetHeight; // Get Navbar Height
            const sectionTop = ref.current.offsetTop; // Get Section Position from Top

            window.scrollTo({
                top: sectionTop - navbarHeight, // Adjust for Navbar height
                behavior: "smooth",
            });
        }
        onClose();
    };



    const handleHomeNavigation = () => {
        if (location.pathname !== "/") {
            navigate("/");
            onClose();
        } else {
            scrollToSection(homeRef);
            onClose();
        }
    };

    const handledNavigateToProjects = (type, dataArray) => {
        setProjectsForType(type, dataArray);
        navigate(`/projects/${type}`);
        onClose();
    };

    // Create menu items for Projects dropdown
    const projectsMenuItems = [{
        key: "1", label: (<div className={"font-roboto font-bold text-lg "}
                               onClick={() => handledNavigateToProjects("domestic", domesticProjects)}>
            Domestic
        </div>),
    }, {
        key: "2", label: (<div className={"font-roboto font-bold text-lg "}
                               onClick={() => handledNavigateToProjects("commercial", commercialProjects)}>
            Commercial
        </div>),
    },];

    const isHomeRoute = location.pathname === "/";

    return (
        <header
            ref={navbarRef}
            className={`mx-2 flex justify-between items-center ${color} px-2 md:px-4 py-1 lg:py-2 rounded-3xl border shadow-md`}
        >
            <div
                className="flex items-center justify-center cursor-pointer h-full"
                onClick={handleHomeNavigation}
            >
                <div className="flex items-center space-x-3">
                    <div className="relative overflow-hidden rounded-lg p-0.5">
                        <img
                            src="../images/CompanyLogo-Landscape.png"
                            alt="SunPledge Logo"
                            className="h-10 w-auto md:h-12 object-cover"
                        />
                    </div>
                    <div className="hidden md:block">
                        <p className="font-bold text-lg md:text-3xl text-blue-950 tracking-wide">
                            SUN PLEDGE <span className="text-yellow-500">HOLDINGS</span>
                        </p>
                    </div>
                </div>
            </div>


            {/* Desktop Navbar */}
            <nav className="hidden lg:flex gap-3">
                <Button type="text" className="custom-navbar-item" onClick={handleHomeNavigation}>
                    Home
                </Button>
                {isHomeRoute && (<>
                    <Button
                        type="text"
                        className="custom-navbar-item"
                        onClick={() => scrollToSection(aboutRef)}
                    >
                        About
                    </Button>
                    <Button
                        type="text"
                        className="custom-navbar-item"
                        onClick={() => scrollToSection(servicesRef)}
                    >
                        Services
                    </Button>
                </>)}
                <Dropdown menu={{items: projectsMenuItems}}
                          placement="bottomCenter">
                    <Button type="text" className="custom-navbar-item flex items-center justify-center">
                        <Space>
                            Projects
                            <DownOutlined/>
                        </Space>
                    </Button>
                </Dropdown>
            </nav>

            {/* Contact Us Button */}
            <div className="contact-button">
                <Button icon={<FaPhone/>} iconPosition={"end"} onClick={() => showDrawer()}>
                    Contact Us
                </Button>
            </div>

            {/* Mobile Drawer Button */}
            <button className="lg:hidden text-2xl" onClick={openDrawer}>
                <div
                    className="px-2 py-1 rounded-full border border-transparent hover:opacity-80 transition-all duration-400">
                    <MenuOutlined className="text-customyellow text-2xl"/>
                </div>
            </button>
            <MobileDrawer
                openMenu={openMenu}
                setOpenMenu={setOpenMenu}
                handleHomeNavigation={handleHomeNavigation}
                isHomeRoute={isHomeRoute}
                scrollToSection={scrollToSection}
                aboutRef={aboutRef}
                servicesRef={servicesRef}
                projectsMenuItems={projectsMenuItems}
                showDrawer={showDrawer}
            />
        </header>);
}

export default Navbar;
